import { z } from 'zod';

export const Ircid = z.string();

export type Ircid = z.infer<typeof Ircid>;
